import React, { Component } from "react";

export default class ReverseDigitSpan extends Component {
  render() {
    var {
      reverse_digit_span_trial1,
      reverse_digit_span_trial2,
      reverse_digit_span_trial2,
      reverse_digit_span_trial3,
      reverse_digit_span_trial4,
      reverse_digit_span_trial5,
      reverse_digit_span_trial6,
      reverse_digit_span_trial7,
      reverse_digit_span_trial8,
      reverse_digit_span_trial9,
      reverse_digit_span_trial10,
      reverse_digit_span_trial11,
      reverse_digit_span_trial12,
      reverse_digit_span_score,
    } = this.props.data;
    return (
      <div className="row border border-dark reverse_digit_span_section">
        <div className="col-lg-10">
        </div>
        <div className="col-lg-2 pt-4" style={{ borderLeft: "1px solid #000" }}>
          <div>
            <span className="fs-18">Score (0-12) </span>
            <input
              disabled
              type="number"
              name="reverse_digit_span_score"
              value={reverse_digit_span_score}
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
